import React from "react";
import { useParams } from "react-router-dom";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import QueryHelper from "components/common/QueryHelper";
import { useGetProcedureStepEvents } from "security-app/hooks/useInvestigationsAPI";
import { listElements } from "./constants";
import { columnRenderers } from "./column-renderers";
import entityActionRender from "./row-actions";
import useTableComponents from "./use-table-components";
const HUMAN_NAME = "Procedure Step Events";
export const IMPLEMENTED_STEP_ACTION_TYPES = {
  perform_search: { groupLabel: "Search Group", stepLabel: "Search All" },
  execute_notification: { groupLabel: "Run Group Notifications", stepLabel: "Run All Notifications" }
};
export const stepWithBulkAction = (step) => {
  var _a, _b, _c, _d;
  return step.action && Object.keys(IMPLEMENTED_STEP_ACTION_TYPES).includes((_b = (_a = step.action) == null ? void 0 : _a.config) == null ? void 0 : _b.type) && !((_d = (_c = step.action) == null ? void 0 : _c.config) == null ? void 0 : _d.use_saved_search);
};
function ProcedureStepEvents({ procedureId, step, isOpened = false }) {
  const { id: invId } = useParams();
  const { getProcedureStepEvents, stepProcedureEventsQueryKeyFn } = useGetProcedureStepEvents(
    invId,
    procedureId,
    step.id,
    isOpened
  );
  const { expandedSections } = useTableComponents();
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: HUMAN_NAME,
      tableLayout: listElements.defaultLayout,
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: HUMAN_NAME }),
      fetchEntities: getProcedureStepEvents,
      keyFn: stepProcedureEventsQueryKeyFn,
      entityAttributesAreCamelCase: false,
      columnRenderers,
      entityActions: step.action ? entityActionRender : void 0,
      expandedSectionRenderers: expandedSections,
      externalSearch: { query: "" },
      withoutURLParams: true,
      noPageSizeSelect: true,
      noColumnReordering: true
    }
  );
}
export default ProcedureStepEvents;
